import { useRef } from 'react'

import { MAX_USING_FEE, MIN_USING_FEE } from '@/entities/map'
import { Button, Slider } from '@/shared/ui'

import { USING_FEE_VALUE_FORMAT } from './value-format'
import { Description, Title } from '../../common/layout'

type Props = {
  ref: (element: HTMLDivElement) => void
  value: number[]
  onValueChange: (value: number[]) => void
  className?: string
}

export const UsingFeeInDefaultView = ({
  ref,
  value,
  onValueChange,
  className,
}: Props) => {
  const rangeRef = useRef<number[]>(value)

  const handleValueChange = (value: number[]) => {
    rangeRef.current = value
  }

  const handleApplyButtonClick = () => {
    onValueChange(rangeRef.current)
  }

  return (
    <div className={className} ref={ref}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Title className="mb-0">가격</Title>
          <Description>1주 임대료 및 관리비</Description>
        </div>
      </div>
      <Slider.Root
        value={value}
        onValueChange={handleValueChange}
        min={MIN_USING_FEE}
        max={MAX_USING_FEE}
        step={50000}
        minStepsBetweenThumbs={1}
        valueFormat={USING_FEE_VALUE_FORMAT}
        className="space-y-1"
      >
        <Slider.Track />
        <div className="flex gap-2">
          <Slider.RangeInput size="small" />
          <Button
            size="medium"
            className="w-12.5 shrink-0"
            onClick={handleApplyButtonClick}
          >
            적용
          </Button>
        </div>
      </Slider.Root>
    </div>
  )
}
